module.exports = __webpack_public_path__ + "img/dao.11b47068.jpg";